// extracted by mini-css-extract-plugin
export default {"arrow-container":"animatedarrow_arrow-container__CRw4W","go-down":"animatedarrow_go-down__B7-dK"};